import $ from 'jquery';

window.addEventListener('load', () => {
  const $flashReportsList = $("#js-flashReportsList");
  const $flashReportsListItem = $("#js-flashReportsList .flash-report-list");
  let flashReportsDom = '';
  let index = $flashReportsListItem.length - 4;
  let exitLoopFlag = false;
  // 速報が2件以下の場合は実行しない
  if($flashReportsListItem.length < 2) { return; }
  // 速報を再配置するため一旦Hideで隠す
  $flashReportsListItem.hide();

  // 最古から3つの速報を表示
  $flashReportsListItem.eq($flashReportsListItem.length - 3).show();
  $flashReportsListItem.eq($flashReportsListItem.length - 2).show();
  $flashReportsListItem.eq($flashReportsListItem.length - 1).show();

  // 最古から4つ目の速報から順に上に追加していく処理
  function downFlashReportsList() {
    flashReportsDom = $flashReportsListItem.eq(index);
    $flashReportsList.prepend(flashReportsDom);
    // 隠れる速報の一つ上のborderを削除
    $flashReportsListItem.eq(index + 2)[0].style.border = "none";
    flashReportsDom.slideDown("slow");
    $("div", flashReportsDom).fadeIn(5000);

    if (index > 0) {
      index--;
    }else{
      exitLoopFlag = true;
    }
  }

  // フォーカスが当たっている場合のみ更新
  let isFocus = true;
  $(window).focus(() => {
    isFocus = true;
  });
  $(window).blur(() => {
    isFocus = false;
  });

  (function loop() {
    if(exitLoopFlag){ return; }
    setTimeout(() => {
      if (isFocus) {
        downFlashReportsList();
      }
      loop();
    }, 5000);
  })();
});
